export default [
  {
    header: 'home'
  },
 /* {
    title: 'home',
    route: 'home',
    icon: 'HomeIcon',
  },*/
  {
    title: 'calendar',
    route: 'calendar',
    icon: 'CalendarIcon',
  },
  {
    title: 'tasks',
    route: 'tasks',
    icon: 'fa-solid fa-list-check',
    iconType: 'font-awesome',
  },
  {
    title: 'hierarchy',
    route: 'hierarchy',
    icon: 'fa-solid fa-folder-tree',
    iconType: 'font-awesome',  },
  /* {
     header: 'reports',
     icon: 'FileIcon',
   },
   {
     title: 'reports',
     route: 'clients',
     icon: 'fa-solid fa-file',
     iconType: 'font-awesome',
   },*/
  {
    header: 'clients',
    icon: 'FileIcon',
  },
   {
    title: 'all',
    route: 'clients',
    icon: 'fa-solid fa-user-group',
    iconType: 'font-awesome',
  },
  {
    title: 'sales',
    route: 'sales',
    icon: 'fa-solid fa-user-tag',
    iconType: 'font-awesome',
  },
  {
    title: 'retention',
    route: 'retention',
    icon: 'fa-solid fa-user-shield',
    iconType: 'font-awesome',
  },
  {
    title: 'clientDashboard',
    route: 'clientDashboard',
    icon: 'fa-solid fa-users',
    iconType: 'font-awesome',
  },
  {
    title: 'clientInsights',
    route: 'clientInsights',
    icon: 'fa-solid fa-crown',
    iconType: 'font-awesome',
  },
  {
    title: 'kycs',
    route: 'kycs',
    icon: 'fa-regular fa-folder-open',
    iconType: 'font-awesome',
  },
  {
    header: 'affiliates',
    icon: 'FileIcon',
  },
  {
    title: 'affiliates',
    route: 'affiliates',
    icon: 'fa-solid fa-building-user',
    iconType: 'font-awesome',
  },
  {
    title: 'leadDistribution',
    route: 'leadDistribution',
    icon: 'fa-solid fa-shuffle',
    iconType: 'font-awesome',
  },
  {
    title: 'affiliateDashboard',
    route: 'affiliateDashboard',
    icon: 'fa-solid fa-chart-column',
    iconType: 'font-awesome',
  },
  {
    header: 'trading',
    icon: 'FileIcon',
  },
  {
    title: 'symbols',
    route: 'symbols',
    icon: 'fa-solid fa-coins',
    iconType: 'font-awesome',
  }, {
    title: 'symbolGroups',
    route: 'symbolGroups',
    icon: 'fa-solid fa-layer-group', //icon: 'fa-brands fa-stack-exchange',
    iconType: 'font-awesome',
  },
  {
    title: 'openTrades',
    route: 'trades',
    icon: 'fa-solid fa-exchange-alt',
    iconType: 'font-awesome',
  },
  {
    title: 'closedTrades',
    route: 'closedTrades',
    icon: 'fa-solid fa-history',
    iconType: 'font-awesome',
  },
  {
    title: 'accounts',
    route: 'accounts',
    icon: 'fa-solid fa-user-circle',
    iconType: 'font-awesome',
  },
  {
    header: 'monetaries',
  },
  {
    title: 'monetaries',
    route: 'monetaries',
    icon: 'CreditCardIcon',
  },
  {
    title: 'withdrawalRequests',
    route: 'withdrawalRequests',
    icon: 'fa-solid fa-wallet',
    iconType: 'font-awesome',
  },
  {
    title: 'monetaryDashboard',
    route: 'monetaryDashboard',
    icon: 'fa-solid fa-money-bill-transfer',
    iconType: 'font-awesome',
  },
  {
    title: 'financeDashboard',
    route: 'financeDashboard',
    icon: 'fa-solid fa-building-columns',
    iconType: 'font-awesome',
  },
  {
    header: 'marketing',
  },
  {
    title: 'leads',
    route: 'leads',
    icon: 'fa-solid fa-user-plus',
    iconType: 'font-awesome',
  },
  {
    title: 'brands',
    route: 'brands',
    icon: 'fa-solid fa-tags',
    iconType: 'font-awesome',
  },
  {

    title: 'campaigns',
    route: 'campaigns',
    icon: 'fa-solid fa-bullhorn',
    iconType: 'font-awesome',
  },
  {

    title: 'facebookPixel',
    route: 'pixels',
    icon: 'fab fa-facebook-f',
    iconType: 'font-awesome',
  },
  {

    title: 'titanAccounts',
    route: 'titans',
    icon: 'fa-solid fa-rocket',
    iconType: 'font-awesome',
  },
  {
    title: 'campaignDashboard',
    route: 'campaignDashboard',
    icon: 'fa-solid fa-chart-line',
    iconType: 'font-awesome'
  },
  {
    header: 'reports',
    icon: 'FileIcon',
  },

  {
    title: 'salesDashboard',
    route: 'salesDashboard',
    icon: 'fa-solid fa-ranking-star',
    iconType: 'font-awesome',
  },

  {
    title: 'mobileDashboard',
    route: 'testDashboard',
    icon: 'fa-solid fa-mobile-screen-button',
    iconType: 'font-awesome',
  },

  {
    title: 'commandCenter',
    route: 'commandCenter',
    icon: 'fa-solid fa-chess-king',
    iconType: 'font-awesome',
  },

  {
    title: 'userInsights',
    route: 'userInsights',
    icon: 'fa-solid fa-medal',
    iconType: 'font-awesome',
  },
  {
    header: 'activity',
    icon: 'ActivityIcon',
  },
  {
    title: 'userActivity',
    route: 'userActivity',
    icon: 'ActivityIcon',
  },
  {
    title: 'clientActivity',
    route: 'clientActivity',
    icon: 'fa-solid fa-timeline',
    iconType: 'font-awesome',
  },
/*
  {
    title: 'userDashboard',
    route: 'userDashboard',
    icon: 'fa-solid fa-comment-dollar',
    iconType: 'font-awesome',
  },*/
  {
    header: 'monitoring',
    icon: 'ActivityIcon',
  },
  {
    title: 'websiteMonitoring',
    route: 'monitoring',
    icon: 'fa-solid fa-heart-pulse',
    iconType: 'font-awesome',
  },
  {
    header: 'dataRecovery',
    icon: 'DatabaseIcon',
  },
  {
    title: 'backupRestore',
    route: 'backupRestore',
    icon: 'fa-solid fa-clock-rotate-left',
    iconType: 'font-awesome',
  },
  {
    header: 'configurations',
    icon: 'SettingsIcon',
  },
  {
    title: 'organizations',
    route: 'organizations',
    icon: 'fa-solid fa-landmark',
    iconType: 'font-awesome',
  },
  {
    title: 'businessesUnits',
    route: 'businessUnit',
    icon: 'fa-solid fa-landmark',
    iconType: 'font-awesome',
  },
  {
    title: 'users',
    route: 'users',
    icon: 'fa-solid fa-users',
    iconType: 'font-awesome',
  },
  {
    title: 'roles',
    route: 'roles',
    icon: 'fa-solid fa-user-tag',
    iconType: 'font-awesome',
  },
  {
    title: 'smtps',
    route: 'smtps',
    icon: 'fa-solid fa-envelope',
    iconType: 'font-awesome',
  },
  {
    title: 'whitelists',
    route: 'whitelists',
    icon: 'fa-solid fa-shield-halved',
    iconType: 'font-awesome',
  },
  {
    title: 'mailTemplates',
    route: 'mails',
    icon: 'fa-solid fa-envelope-open-text',
    iconType: 'font-awesome',
  },
  {
    title: 'clientStatuses',
    route: 'clientStatus',
    icon: 'fa-solid fa-stream',
    iconType: 'font-awesome',
  },
  {
    title: 'psps',
    route: 'psp',
    icon: 'fa-solid fa-credit-card',
    iconType: 'font-awesome',
  },

  {
    header: 'help',
  },
  {
    title: 'tickets',
    route: 'tickets',
    icon: 'fa-solid fa-ticket',
    iconType: 'font-awesome',
    tag: 'data/getTickers',
    tagVariant: "danger",
  },
  {
    title: 'support',
    route: 'config-support',
    iconType: 'font-awesome',
    icon: 'fa-solid fa-headset',
  },
  {
    title: 'about',
    route: 'config-about',
    iconType: 'font-awesome',
    icon: 'fa-regular fa-circle-question',
  },

  // Mobile-only section — items flagged mobileOnly are filtered out of the
  // menu on desktop viewports (see VerticalNavMenuItems.filteredItems).
  {
    header: 'mobile',
    mobileOnly: true,
  },
  {
    title: 'testDashboard',
    route: 'testDashboard',
    icon: 'fa-solid fa-mobile-screen-button',
    iconType: 'font-awesome',
    mobileOnly: true,
  }
];
